import { render, staticRenderFns } from "./BDCUAAEH.vue?vue&type=template&id=27cade8f&scoped=true&"
import script from "./BDCUAAEH.vue?vue&type=script&lang=js&"
export * from "./BDCUAAEH.vue?vue&type=script&lang=js&"
import style0 from "./BDCUAAEH.vue?vue&type=style&index=0&id=27cade8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cade8f",
  null
  
)

export default component.exports